// User

const goToEditTeams = (state) => {
  return {
    ...state,
    userPageStatus: "edit teams"
  }
}

export default goToEditTeams